import { SyncFn } from './sync-coordinator';
import { getAlignmentSyncPosition } from './source-positions';
import { applyToMap } from './apply-to-map';

/**
 * Syncs from an alignment source pane to a map (top-down) target pane.
 * Centers the map camera on the alignment point when not visible and
 * propagates source quaternion + fov to the target frustum.
 *
 * Alignment source orientation is always meaningful — cross-section is not
 * considered here because the frustum overlay is a display indicator, not
 * a navigation update.
 */
export const syncAlignmentToMap: SyncFn = async (source, target) => {
  const syncPosition = getAlignmentSyncPosition(source);
  if (!syncPosition) return;

  const sourceViewer = source.viewerWrapper()?.viewer;
  const targetViewer = target.viewerWrapper()?.viewer;
  if (!sourceViewer || !targetViewer) return;

  applyToMap(target, targetViewer, sourceViewer, syncPosition, true);
};
